import React, { useState, useEffect } from 'react'
import {
  Button,
  Header,
  Icon,
  Modal,
  Segment,
  Message,
  List,
  Dropdown,
} from 'semantic-ui-react'
import PropTypes from 'prop-types'
// import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import contains from 'validator/es/lib/contains'
// import { CreateDeviceCreateTemplateXlsx } from '../../services/device'
import { UploadColdCreationFile } from '../../services/configuration-template'
import deviceCold from '../../dummies/device-cold.xlsx'
import { CreateXlsx } from '../../services/xlsx'
import { primaryColor } from '../../constants'
import IntelMsg from '../ItelMsg/index'
import { RefreshCustomerDeviceList } from '../../redux/actions/devices'
import { GetUserCustomers } from '../../services/asset/index'
import { setCustomerData } from '../../redux/actions/deviceData'

const DeviceBulkUpload = ({ showDeviceBulk, setDeviceBulkShow }) => {
  const [message, setMessage] = useState()

  // const { t } = useTranslation()
  const dispatch = useDispatch()
  const { userEmail, deviceType } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
    productName: store.product.productName,
    deviceType: store.product.deviceType,
    customer: store.asset.customer,
  }))

  const [customerId, setCustomerId] = useState()
  const [customerList, setCustomersList] = useState()
  const productName = localStorage.getItem('product')
  console.log(
    'email,productName,deviceType',
    userEmail,
    productName,
    deviceType,
  )
  const customerData = []
  useEffect(() => {
    GetUserCustomers(userEmail, productName).then((customers) => {
      customers.forEach((element) => {
        customerData.push({
          text: element.title,
          value: element.tbCustomerId,
        })
      })
      setCustomersList(customerData)
    })
  }, [])
  const createReport = (data) => {
    const FilesIssuesHeaders = ['Row Number', 'Device Issue']
    const FileIssuesRaw = data['File errors']
    const FileIssuesIssues = []

    // eslint-disable-next-line no-restricted-syntax,guard-for-in
    for (const [key, value] of Object.entries(FileIssuesRaw)) {
      let rowIssues = value.reduce(
        (string, rowIssue) => `${rowIssue}, ${string}`,
        '',
      )
      rowIssues = rowIssues.slice(0, -1)
      const issue = {
        'Row Number': key,
        'Device Issue': rowIssues.slice(0, -1),
      }
      FileIssuesIssues.push(issue)
    }
    CreateXlsx('Devices Issues', FilesIssuesHeaders, FileIssuesIssues)
  }

  const createMessageContent = (data) => {
    const totalUploadedDevices = (
      <List.Item>
        <IntelMsg id="totalDevices" />
        &nbsp;
        {data['Total no. of failure'] + data['Total no. of success']}
      </List.Item>
    )

    const totalSucessDevices = (
      <List.Item>
        <IntelMsg id="successDevices" />
        &nbsp;{data['Total no. of success']}
      </List.Item>
    )
    const faluireDecvices = (
      <List.Item>
        Failed Devices:&nbsp;{data['Total no. of failure']}{' '}
      </List.Item>
    )
    return (
      <List bulleted>
        {totalUploadedDevices}
        {totalSucessDevices}
        {faluireDecvices}
      </List>
    )
  }

  const createErrorMessage = (header, content) => {
    const errorMessage = (
      <Message negative>
        <Message.Header>{header}</Message.Header>
        {content}
      </Message>
    )
    setMessage(errorMessage)
  }
  const handleUpload = (event) => {
    const file = event.target.files[0]
    if (file && contains(file.name, '.xlsx')) {
      UploadColdCreationFile(
        userEmail,
        productName,
        customerId,
        deviceType,
        file,
      ).then((res) => {
        if (res.success) {
          dispatch(RefreshCustomerDeviceList(true))
          setMessage('')
          setMessage(
            <Message positive>
              <Message.Header> Result</Message.Header>
              {createMessageContent(res.data)}
              <p>
                Issues report &nbsp;
                <Button size="tiny" onClick={() => createReport(res.data)}>
                  <Icon name="download"></Icon>Export
                </Button>
              </p>
            </Message>,
          )
        } else {
          createErrorMessage('Error !', res.msg)
        }
      })
    } else {
      createErrorMessage(
        'Invalid File Type',
        "File extension should be 'xlsx' ",
      )
    }
  }

  const handleClose = () => {
    setMessage(null)
    setCustomerId()
    setDeviceBulkShow(false)
  }

  return (
    <>
      {customerId ? (
        <Modal
          closeIcon
          open={showDeviceBulk}
          centered
          style={{ position: 'relative', height: 'auto' }}
          onClose={() => handleClose()}
          onOpen={() => setDeviceBulkShow(true)}
        >
          <Header
            icon="archive"
            content=" Device Bulk Creation "
            style={{ backgroundColor: '#1678c2', color: 'white' }}
          />
          <Modal.Content scrolling>
            <Segment placeholder>
              <Header icon>
                <Icon name="cog" />
                Upload Configurations file
              </Header>
              <Segment.Inline>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '29rem',
                    justifyContent: 'space-between',
                  }}
                >
                  <input
                    type="file"
                    accept=".xlsx"
                    onClick={(event) => {
                      /* eslint-disable-next-line no-param-reassign */
                      event.target.value = null
                    }}
                    onChange={(event) => handleUpload(event)}
                    id="upload"
                    style={{ display: 'none' }}
                  />

                  <label htmlFor="upload">
                    <Button
                      style={{ backgroundColor: primaryColor, color: 'white' }}
                      onClick={() => document.getElementById('upload').click()}
                    >
                      <Icon name="upload" />
                      Upload Excel File
                    </Button>
                  </label>

                  <a href={deviceCold} download="device.xlsx">
                    <Button primary type="button">
                      <Icon name="download" />
                      Download Template
                    </Button>
                  </a>
                </div>
              </Segment.Inline>
            </Segment>

            {message}
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="#303d54"
              style={{ backgroundColor: primaryColor, color: 'white' }}
              onClick={() => {
                handleClose()
              }}
            >
              Close
            </Button>
          </Modal.Actions>
        </Modal>
      ) : (
        <Modal
          closeIcon
          open={showDeviceBulk}
          centered
          style={{ position: 'relative', height: 'auto' }}
          onClose={() => handleClose()}
          onOpen={() => setDeviceBulkShow(true)}
        >
          <Header
            icon="archive"
            content=" Device Bulk Creation "
            style={{ backgroundColor: '#1678c2', color: 'white' }}
          />
          <Modal.Content scrolling>
            <Segment placeholder>
              <Header icon>
                <Icon name="address card" />
                Select Customer
              </Header>

              <Dropdown
                placeholder="You have to select Customer"
                fluid
                search
                selection
                options={customerList}
                onChange={(e, data) => {
                  setCustomerId(data.value)
                  dispatch(setCustomerData(data.value))
                  localStorage.setItem('customer', data.value)
                }}
              />
            </Segment>

            {message}
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="#303d54"
              style={{ backgroundColor: primaryColor, color: 'white' }}
              onClick={() => {
                handleClose()
              }}
            >
              Close
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </>
  )
}
DeviceBulkUpload.propTypes = {
  setDeviceBulkShow: PropTypes.func.isRequired,
  showDeviceBulk: PropTypes.bool.isRequired,
}

// const dataSet1 = []

export default DeviceBulkUpload
